"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slideWithProps = exports.translateWithProps = exports.originWithProps = exports.scaleWithProps = exports.slide = exports.expand = exports.minus = exports.calc = exports.origin = exports.translate3d = exports.excludeTransition = exports.getTransitionArray = exports.hasTransition = void 0;
const tslib_1 = require("tslib");
const react_core_1 = require("@neo-one/react-core");
const styled_tools_1 = require("styled-tools");
exports.hasTransition = (props) => Boolean(props.animated || props.fade || props.slide || props.expand);
exports.getTransitionArray = (props) => [props.animated, props.fade, props.slide, props.expand];
exports.excludeTransition = (props) => {
    const { animated: _animated, fade: _fade, slide: _slide, expand: _expand } = props, rest = tslib_1.__rest(props, ["animated", "fade", "slide", "expand"]);
    return rest;
};
exports.translate3d = (x, y, z) => `translate3d(${react_core_1.numberToPx(x)}, ${react_core_1.numberToPx(y)}, ${react_core_1.numberToPx(z)})`;
exports.origin = (x = 'center', y = 'center') => `${react_core_1.numberToPx(x)} ${react_core_1.numberToPx(y)}`;
exports.calc = (a, b) => `calc(${react_core_1.numberToPx(a)} + ${react_core_1.numberToPx(b)})`;
exports.minus = (v) => `-${react_core_1.numberToPx(v)}`;
exports.expand = styled_tools_1.ifProp({ expand: true }, styled_tools_1.prop('defaultExpand', 'center'), styled_tools_1.prop('expand'));
exports.slide = styled_tools_1.ifProp({ slide: true }, styled_tools_1.prop('defaultSlide', 'right'), styled_tools_1.prop('slide'));
exports.scaleWithProps = styled_tools_1.ifProp('expand', 'scale(0.01)');
const originFunc = (x, y) => styled_tools_1.switchProp(exports.expand, {
    center: exports.origin(exports.calc('50%', x), exports.calc('50%', y)),
    top: exports.origin(exports.calc('50%', x), exports.calc('100%', y)),
    right: exports.origin(x, exports.calc('50%', y)),
    bottom: exports.origin(exports.calc('50%', x), y),
    left: exports.origin(exports.calc('100%', x), exports.calc('50%', y)),
}, exports.origin(exports.calc('50%', x), exports.calc('50%', y)));
exports.originWithProps = styled_tools_1.withProp(['originX', 'originY'], originFunc);
exports.translateWithProps = styled_tools_1.withProp(['translateX', 'translateY'], exports.translate3d);
exports.slideWithProps = styled_tools_1.withProp(['translateX', 'translateY', 'slideOffset'], (x, y, offset = '100%') => styled_tools_1.switchProp(exports.slide, {
    top: exports.translate3d(x, exports.calc(offset, y)),
    right: exports.translate3d(exports.calc(exports.minus(offset), x), y),
    bottom: exports.translate3d(x, exports.calc(exports.minus(offset), y)),
    left: exports.translate3d(exports.calc(offset, x), y),
}, exports.translate3d(x, y)));

//# sourceMappingURL=transition.js.map
